import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsDateString,
  IsEnum,
  IsMongoId,
  IsNotEmpty,
  IsOptional,
  IsString,
  Length,
  Matches,
  ValidateNested,
} from 'class-validator';
import { AgentCardId } from '../../../../types/etxe-branded-object-ids.type';
import { AgentType } from '../agent-profile/agent-profile.dto';

export class AgentCardAddressDto {
  @IsString()
  @IsOptional()
  streetNumber?: string;

  @IsString()
  @IsOptional()
  streetType?: string;

  @IsString()
  @IsOptional()
  streetName?: string;

  @IsString()
  @IsOptional()
  zipCode?: string;

  @IsString()
  @IsOptional()
  city?: string;

  @IsString()
  @IsOptional()
  departmentCode?: string;

  @IsString()
  @IsOptional()
  complement?: string;

  @IsString()
  @IsOptional()
  specialDistribution?: string;

  @IsString()
  @IsOptional()
  repetitionIndex?: string;
}

export class AgentCardLeaderDto {
  @IsString()
  @IsNotEmpty()
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  lastName!: string;
}

export class AgentCardMentionsDto {
  @IsBoolean()
  transaction!: boolean;

  @IsBoolean()
  management!: boolean;

  @IsBoolean()
  listBroker!: boolean;

  @IsBoolean()
  tourism!: boolean;

  @IsBoolean()
  service!: boolean;

  @IsBoolean()
  syndic!: boolean;
}

export class AgentCardInsurerDto {
  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => AgentCardAddressDto)
  address?: AgentCardAddressDto;
}

export class AgentCardCciDto {
  @IsString()
  @IsNotEmpty()
  id!: string;

  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => AgentCardLeaderDto)
  president?: AgentCardLeaderDto;
}

export class AgentCardDto {
  @IsMongoId()
  @IsNotEmpty()
  _id!: AgentCardId;

  @IsString()
  @IsNotEmpty()
  number!: string;

  @IsEnum(['titulaire', 'mandataire'])
  @IsOptional()
  type?: AgentType;

  @IsString()
  @IsNotEmpty()
  companyName!: string;

  @IsString()
  @Length(9, 9)
  @Matches(/^[0-9]{9}$/, { message: 'SIREN must be 9 digits' })
  @IsNotEmpty()
  siren!: string;

  @IsString()
  @Length(14, 14)
  @Matches(/^[0-9]{14}$/, { message: 'SIRET must be 14 digits' })
  @IsOptional()
  siret?: string;

  @IsString()
  @IsNotEmpty()
  legalForm!: string;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => AgentCardCciDto)
  cci!: AgentCardCciDto;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => AgentCardAddressDto)
  address!: AgentCardAddressDto;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => AgentCardLeaderDto)
  leader!: AgentCardLeaderDto;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => AgentCardMentionsDto)
  mentions!: AgentCardMentionsDto;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => AgentCardInsurerDto)
  insurer!: AgentCardInsurerDto;

  @IsDateString()
  @IsNotEmpty()
  expiresAt!: string;

  @IsBoolean()
  @IsOptional()
  isActive?: boolean = true;
}

export class AgentCardVerificationDto {
  @IsString()
  @IsNotEmpty()
  number!: string;
}

export class AgentCardCreationDto {
  @IsString()
  @IsNotEmpty()
  number!: string;

  @IsEnum(['titulaire', 'mandataire'])
  @IsNotEmpty()
  type!: AgentType;
}
